import { api } from '../utils';

export const getTariffAction = async (tag, country_iso_code) => {
  try {
    return await api('/tariffs/determine-for-registration', { tag, country_iso_code }, 'GET');
  } catch (e) {
    throw e;
  }
};
